export const AUCTION_TYPES = ['diamonds', 'jewelry', 'watches'];

export const CLARITY_SLIDERS_DATA = {
  1: { label: 'I3' },
  2: { label: 'I2' },
  3: { label: 'I1' },
  4: { label: 'SI2' },
  5: { label: 'SI1' },
  6: { label: 'VS2' },
  7: { label: 'VS1' },
  8: { label: 'VVS2' },
  9: { label: 'VVS1' },
  10: { label: 'IF' },
  11: { label: 'FL' },
};

export const COLOR_SLIDER_DATA = {
  1: { label: 'M-Z' },
  2: { label: 'L' },
  3: { label: 'K' },
  4: { label: 'J' },
  5: { label: 'I' },
  6: { label: 'H' },
  7: { label: 'G' },
  8: { label: 'F' },
  9: { label: 'E' },
  10: { label: 'D' },
};

export const STONE_TYPE_DATA = [
  { text: 'All', value: 0 },
  { text: 'Natural Diamond', value: 'Natural' },
  { text: 'Lab-grown Diamond', value: 'Lab Grown' },
  { text: 'Gemstone', value: 'Gemstone' },
];

export const TREATED_STONE_DATA = [
  { text: 'All', value: 0 },
  { text: 'Not treated', value: 'No' },
  { text: 'Treated', value: 'Yes' },
];

export enum FilterTypesEnum {
  select = 'select',
  range = 'range',
  toggle = 'toggle',
  checkbox = 'checkbox',
}

export enum FilterNamesEnum {
  stoneType = 'stoneType',
  treatedStone = 'treatedStone',
  jewelryType = 'jewelryType',
  certificate = 'certificate',
  brand = 'brand',
  gender = 'gender',
  shape = 'shape',
  carat = 'carat',
  clarity = 'clarity',
  color = 'color',
  enhanced = 'enhanced',
  fancy = 'fancy',
  nonDiamond = 'nonDiamond',
}

export enum QuickFiltersEnum {
  watch = 'watch',
  outbid = 'outbid',
  inTheLead = 'inTheLead',
  suggested = 'suggested',
}

export enum PersonalizedFiltersEnum {
  suggested = 'suggested',
  new = 'new',
  trending = 'trending',
  watch = 'watch',
  notViewed = 'notViewed',
}

export const filters: { [key in AuctionsTypes.FilterNames]: AuctionsTypes.FilterFields } = {
  stoneType: {
    label: 'Stone type',
    type: FilterTypesEnum.select,
    name: FilterNamesEnum.stoneType,
    isMulti: true,
  },
  treatedStone: {
    label: 'Treated stone',
    type: FilterTypesEnum.select,
    name: FilterNamesEnum.treatedStone,
    isMulti: true,
  },
  jewelryType: {
    label: 'Jewelry type',
    type: FilterTypesEnum.select,
    name: FilterNamesEnum.jewelryType,
    isMulti: true,
  },
  certificate: {
    label: 'Certificate',
    type: FilterTypesEnum.select,
    name: FilterNamesEnum.certificate,
    isMulti: true,
  },
  brand: {
    label: 'Brand',
    type: FilterTypesEnum.select,
    name: FilterNamesEnum.brand,
    isMulti: true,
  },
  gender: {
    label: 'Gender',
    type: FilterTypesEnum.select,
    name: FilterNamesEnum.gender,
    isMulti: true,
  },
  shape: {
    label: 'Shape',
    type: FilterTypesEnum.select,
    name: FilterNamesEnum.shape,
    isMulti: true,
  },
  carat: {
    label: 'Carat',
    type: FilterTypesEnum.range,
    name: FilterNamesEnum.carat,
  },
  clarity: {
    label: 'Clarity',
    type: FilterTypesEnum.range,
    name: FilterNamesEnum.clarity,
    data: CLARITY_SLIDERS_DATA,
  },
  color: {
    label: 'Color',
    type: FilterTypesEnum.range,
    name: FilterNamesEnum.color,
    data: COLOR_SLIDER_DATA,
  },
  enhanced: {
    label: 'Enhanced',
    type: FilterTypesEnum.toggle,
    name: FilterNamesEnum.enhanced,
  },
  fancy: {
    label: 'Fancy',
    type: FilterTypesEnum.toggle,
    name: FilterNamesEnum.fancy,
  },
  nonDiamond: {
    label: 'Non-diamond',
    type: FilterTypesEnum.toggle,
    name: FilterNamesEnum.nonDiamond,
  },
};

export const QuickFilters: { [key in QuickFiltersEnum]: AuctionsTypes.QuickFiltersField } = {
  watch: {
    label: 'Following',
    type: FilterTypesEnum.checkbox,
    name: QuickFiltersEnum.watch,
  },
  outbid: {
    label: 'Outbid',
    type: FilterTypesEnum.checkbox,
    name: QuickFiltersEnum.outbid,
  },
  inTheLead: {
    label: 'In the lead',
    type: FilterTypesEnum.checkbox,
    name: QuickFiltersEnum.inTheLead,
  },
  suggested: {
    label: 'Suggested for you',
    type: FilterTypesEnum.checkbox,
    name: QuickFiltersEnum.suggested,
  },
};

export const PersonalizedFilters: {
  [key in PersonalizedFiltersEnum]: AuctionsTypes.PersonalizedFiltersField;
} = {
  suggested: {
    label: 'Suggested for you',
    type: FilterTypesEnum.toggle,
    name: PersonalizedFiltersEnum.suggested,
    icon: 'suggested',
  },
  new: {
    label: 'New',
    type: FilterTypesEnum.toggle,
    name: PersonalizedFiltersEnum.new,
    icon: 'new',
  },
  trending: {
    label: 'Trending',
    type: FilterTypesEnum.toggle,
    name: PersonalizedFiltersEnum.trending,
    icon: 'hot',
  },
  watch: {
    label: 'Following',
    type: FilterTypesEnum.toggle,
    name: PersonalizedFiltersEnum.watch,
    icon: 'watching',
  },
  notViewed: {
    label: 'Not viewed',
    type: FilterTypesEnum.toggle,
    name: PersonalizedFiltersEnum.notViewed,
    icon: 'notViewed',
  },
};

const diamondFilters = [
  filters.stoneType,
  // filters.nonDiamond,
  filters.certificate,
  filters.shape,
  filters.carat,
  filters.clarity,
  // filters.enhanced,
  filters.color,
  filters.fancy,
  filters.treatedStone,
];

const jewelryFilters = [
  filters.jewelryType,
  // filters.nonDiamond,
  filters.stoneType,
  filters.certificate,
  filters.brand,
  filters.shape,
  filters.carat,
  filters.clarity,
  // filters.enhanced,
  filters.color,
  filters.fancy,
  filters.treatedStone,
];

const watchesFilters = [filters.brand, filters.gender];

const diamondQuickFilters = [QuickFilters.watch, QuickFilters.suggested];

const jewelryQuickFilters = [QuickFilters.watch, QuickFilters.suggested];

const watchesQuickFilters = [QuickFilters.watch, QuickFilters.suggested];

const personalizedFilters = [
  PersonalizedFilters.suggested,
  PersonalizedFilters.watch,
  PersonalizedFilters.notViewed,
  PersonalizedFilters.trending,
];

export const typeToFilters = {
  diamonds: diamondFilters,
  jewelry: jewelryFilters,
  watches: watchesFilters,
};

export const typeToQuickFilters = {
  diamonds: diamondQuickFilters,
  jewelry: jewelryQuickFilters,
  watches: watchesQuickFilters,
};

export const typeToPersonalizedFilters = {
  diamonds: personalizedFilters,
  jewelry: personalizedFilters,
  watches: personalizedFilters,
};

export const RANGE_FILTER_WIDTH = {
  [FilterNamesEnum.carat]: '425px',
  [FilterNamesEnum.color]: '425px',
  [FilterNamesEnum.clarity]: '512px',
};

export const FE_FILTERS = [
  'stoneType',
  'treatedStone',
  'watch',
  'outbid',
  'inTheLead',
  'suggested',
  'notViewed',
  'trending',
];
